import type {
  AnalyticsEventName,
  AnalyticsEventProperties,
} from '../schemas/analytics/analyticsEventSchema';

/**
 * One way for every app to send product analytics events to PostHog, typed by
 * `analyticsEventSchemas`. Each app builds its `track` with this in its own `analytics.ts`. Rules:
 * `posthog/README.md`.
 */
export const createTracker =
  ({
    posthog,
  }: {
    posthog: { capture(event: string, properties?: Record<string, unknown>): void };
  }) =>
  <E extends AnalyticsEventName>(event: E, properties: AnalyticsEventProperties<E>) => {
    posthog.capture(event, properties);
  };
